import { User } from 'shared/types/user';
import { initialWeekStartsOn } from 'shared/types/week-days';

export const getWeekStartsOn = (user?: User | null) =>
  user?.settings?.startOfWeek ?? initialWeekStartsOn;
